import { useIntl } from 'react-intl';

import messages from './messages';
import { Background, Content, Headline, HeadlineContainer, Logo, SubHeadline, Wrapper } from './styles';

const Hero = () => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<Background src="/_n/images/jasper-lake.webp" />
			<Content>
				<HeadlineContainer>
					<Logo src="/_n/images/calm-logo-square.png" alt="Calm logo" />
					<Headline>{formatMessage(messages.headline)}</Headline>
				</HeadlineContainer>
				<SubHeadline>{formatMessage(messages.subHeadline)}</SubHeadline>
			</Content>
		</Wrapper>
	);
};

export default Hero;
